/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Services_Event_BodyInputs */

const ja_playdata_home_services_event_body = /** @type {(inputs: Playdata_Home_Services_Event_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツイベントを指定して、日程ごとに最大同時視聴者数、平均同時視聴者数、累計視聴時間を確認できます。また、ミラー配信など含めた配信チャンネルごとの視聴データも把握できます。`)
};

const en_playdata_home_services_event_body = /** @type {(inputs: Playdata_Home_Services_Event_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an esports event and review peak concurrent viewers, average concurrent viewers and cumulative watch time by date. Viewership is also broken down per streaming channel, including mirror broadcasts.`)
};

/**
* | output |
* | --- |
* | "Choose an esports event and review peak concurrent viewers, average concurrent viewers and cumulative watch time by date. Viewership is also broken down per ..." |
*
* @param {Playdata_Home_Services_Event_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_services_event_body = /** @type {((inputs?: Playdata_Home_Services_Event_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Services_Event_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_services_event_body(inputs)
	return en_playdata_home_services_event_body(inputs)
});